import { render, staticRenderFns } from "./contact-details-p2.vue?vue&type=template&id=a6943950&scoped=true"
import script from "./contact-details-p2.vue?vue&type=script&lang=js"
export * from "./contact-details-p2.vue?vue&type=script&lang=js"
import style0 from "./contact-details-p2.vue?vue&type=style&index=0&id=a6943950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6943950",
  null
  
)

export default component.exports